var _defs, _rect, _polygon, _polygon2, _rect2, _polygon3, _polygon4, _polygon5, _polygon6, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBggraMob06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 415.61 5482.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-10,.cls-11,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{opacity:0.8;}.cls-2{fill:url(#radial-gradient-2);}.cls-3{fill:url(#radial-gradient-3);}.cls-4{fill:url(#radial-gradient-4);}.cls-5{fill:url(#radial-gradient-5);}.cls-6{fill:url(#radial-gradient-6);}.cls-7{fill:url(#radial-gradient-7);}.cls-8{fill:url(#radial-gradient-8);}.cls-9{fill:url(#radial-gradient-9);}.cls-10{fill:url(#radial-gradient-10);}.cls-11{fill:url(#radial-gradient-11);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 213.87,
    cy: 2241.01,
    r: 203.97,
    gradientTransform: "translate(0) scale(0.97 1.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f987ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#f99af0",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f8c3f3",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f8e0f6",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f8f2f7",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f8f8f8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1779.37,
    cy: 2711.22,
    r: 350.23,
    gradientTransform: "translate(-839.01 -445.91) scale(0.54 0.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85db16",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ade565",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d6f0b6",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#eff6e7",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f8f8f8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 2054.46,
    cy: 3098.39,
    r: 350.23,
    gradientTransform: "translate(-826.86 -381.24) scale(0.53 0.34)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 68.37,
    cy: 742.54,
    r: 1100.17,
    gradientTransform: "translate(242.48 591.32) scale(0.27 0.44)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 1728.87,
    cy: 4269.75,
    r: 350.23,
    gradientTransform: "translate(-839.01 -185.61) scale(0.54 0.34)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 2088.75,
    cy: 5227.03,
    r: 601.35,
    gradientTransform: "translate(-839.01 -900.57) scale(0.54 0.53)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 2088.75,
    cy: 6830.94,
    r: 601.35,
    gradientTransform: "translate(-839.01 -482.12) scale(0.54 0.53)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 2088.75,
    cy: 8353.96,
    r: 601.35,
    gradientTransform: "translate(-839.01 -84.78) scale(0.54 0.53)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 66.87,
    cy: 4456.39,
    r: 1100.17,
    gradientTransform: "translate(242.49 1879.64) scale(0.27 0.44)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 515.02,
    cy: 195.58,
    r: 664.16,
    gradientTransform: "translate(242.48 401.59) scale(0.27 0.44)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -555.43,
    cy: 5326.4,
    r: 806.93,
    gradientTransform: "translate(242.49 3576.51) scale(0.27 0.17)",
    xlinkHref: "#radial-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 414,
    height: 5482.36
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "414.56 732.79 3.7 732.79 1.61 300.79 415.61 300.79 414.56 732.79"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "410.96 996.15 4.88 996.15 2.81 564.15 412 564.15 410.96 996.15"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.81,
    y: 283.04,
    width: 411.6,
    height: 1258.92
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "413.36 1552.23 2.5 1552.23 0.4 1120.23 414.4 1120.23 413.36 1552.23"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "412.95 2205.6 2.1 2205.6 0 1530.79 414 1530.79 412.95 2205.6"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "412.95 3473.64 2.1 3473.64 0 2798.83 414 2798.83 412.95 3473.64"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "412.95 4677.72 2.1 4677.72 0 4002.91 414 4002.91 412.95 4677.72"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2.4,
    y: 3193.07,
    width: 411.6,
    height: 1258.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1.2,
    width: 411.6,
    height: 1258.92
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2.4,
    y: 4000.39,
    width: 411.6,
    height: 1258.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBggraMob06);
export default __webpack_public_path__ + "static/media/bggra-mob-06.51f489036e09bcc1be990f1d7a3f521d.svg";
export { ForwardRef as ReactComponent };